export const environment = {
  production: true,
  PIXIE_BASE_URL: 'https://app.wondercard.ru',
  BACKEND_BASE_URL: 'https://wondercard-api.moscow.wondersellcloud.ru',
  MARKETING_BASE_URL: 'https://wondercard.ru',
  DEFAULT_STATE_ID: '348b0268-ec3f-4b2e-9c0a-53df7f70695e',
  CLIPPINGMAGIC_TEST_MODE: false,
  AMPLUTUDE_API_KEY: 'ce0bbf9862d407fd77247a776f033479',
};
